import React from "react";
import { useForm } from "react-hook-form";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
import toast from "react-hot-toast";
import { useState } from "react";

const GiveNotice = ({ setLoadNoticeModal, currentCheckIn }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [load, setLoad] = useState(false);
  const noticeUpdate = (data) => {
    setLoad(true);
    const myData = {
      notice: {
        UnderNotice: true, // Default set to true
        reasonOfNotice: data.reasonOfNotice,
        noticeRaisedOn: new Date(), // Current date
        leavingDate: data.leavingDate,
      },
    };

    const config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/check_in/give_notice/${currentCheckIn?._id}`,
      headers: {},
      data: myData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am data----->", response.data);
        toast.success("Notice Updated Successfully..");
        setLoadNoticeModal(false); // Close modal on success
        setLoad(false);
      })
      .catch((error) => {
        toast.error("Error, Processing Further!");
        setLoad(false);
        console.error(error);
      });
  };

  return (
    <div className="bg-[black]/10 backdrop-blur-sm fixed inset-0 w-full z-50 flex justify-center items-center ">
      <div className="w-[40rem] bg-white h-auto rounded-md relative p-6">
        <AiFillCloseCircle
          onClick={() => {
            setLoadNoticeModal(false);
          }}
          className="cursor-pointer text-primaryColor absolute top-4 right-4 "
          size={30}
        />
        <h2 className="text-xl font-semibold mb-4">Customer Details</h2>
        <div className="text-gray-700 grid grid-cols-2">
          <p>
            <strong>Name:</strong> {currentCheckIn?.name || "N/A"}
          </p>
          <p>
            <strong>Email:</strong> {currentCheckIn?.email || "N/A"}
          </p>
          <p>
            <strong>Contact Number:</strong> {currentCheckIn?.mobile || "N/A"}
          </p>
          <p>
            <strong>Building Name:</strong>{" "}
            {currentCheckIn?.hostelName?.nameBuilding || "N/A"}
          </p>
          <p>
            <strong>Floor Number:</strong> Floor-
            {currentCheckIn?.floorNo || "N/A"}
          </p>
          <p>
            <strong>Room Number:</strong> R-F{currentCheckIn?.floorNo}
            {String(currentCheckIn?.roomId?.roomNumber).padStart(3, "0")}
          </p>
          <p>
            <strong>Bed Number:</strong>{" "}
            {currentCheckIn?.bedId?.bedNumber || "N/A"}
          </p>
        </div>

        <div className="mt-6">
          <h2 className="text-xl font-semibold mb-4">Notice Details</h2>
          <form onSubmit={handleSubmit(noticeUpdate)}>
            <div className="mb-4">
              <label
                htmlFor="reasonOfNotice"
                className="block text-gray-700 font-medium mb-2"
              >
                Reason of Notice
              </label>
              <textarea
                id="reasonOfNotice"
                {...register("reasonOfNotice", {
                  required: "Reason is required",
                })}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-primaryColor"
                placeholder="Enter the reason for notice"
              />
              {errors.reasonOfNotice && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.reasonOfNotice.message}
                </p>
              )}
            </div>

            <div className="mb-4">
              <label
                htmlFor="leavingDate"
                className="block text-gray-700 font-medium mb-2"
              >
                Leaving Date
              </label>
              <input
                type="date"
                id="leavingDate"
                {...register("leavingDate", {
                  required: "Leaving date is required",
                })}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-primaryColor"
              />
              {errors.leavingDate && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.leavingDate.message}
                </p>
              )}
            </div>

            <div className="mt-6 flex justify-end">
              <button
                type="submit"
                className="bg-primaryColor hover:bg-primaryBtnHoverColor text-white px-4 py-2 rounded-md hover:bg-primaryColor-dark focus:outline-none"
              >
                {load ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GiveNotice;
